import React, { useState } from 'react';
import { MediaButton } from '../media-button';
import RotatableGallery from '../three-sixty/rotatable-gallery';

interface ThreeSixtyFullscreenProps {
  urls: {
    webp?: string | undefined;
    url: string;
  }[];
  imageAlt?: string;
}

const ThreeSixtyFullscreen = ({ urls, imageAlt }: ThreeSixtyFullscreenProps) => {
  const [initiated, setInitiated] = useState(false);

  const initiate = (e: React.MouseEvent<HTMLDivElement | HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setInitiated(true);
  };

  if (initiated) {
    return (
      <div>
        <RotatableGallery images={urls} imageAlt={imageAlt} fullscreen={true} />
      </div>
    );
  }

  return (
    <div
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <picture>
        {urls[0].webp && <source type="image/webp" srcSet={urls[0].webp} />}
        <img src={urls[0].url} alt={imageAlt} className="lightbox-image l-full" />
      </picture>
      <div className="lightbox-item-action">
        <MediaButton text="Starta 360° exteriört" onClick={initiate} icon="360" />
      </div>
      <div className="lightbox-item-360-badge" />
    </div>
  );
};

export default ThreeSixtyFullscreen;
